import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { get } from 'lodash';
import { useEntry } from '../../hooks/useEntry';
import { useSweep } from '../../hooks/useSweep';
import { SweepDetailPage } from '.';
import { useAuth, useLoginActions } from '../../hooks/useAuth';
import { useFeatures } from '../../hooks/useFeatures';
import { usePromotions } from '../../hooks/usePromotions';
import { getBettingStatus } from '../../helpers/betHelpers';
import { getPromotionConfig } from '../../helpers/promotions';
import { checkIfExcludedFrom } from '../../utils/authUtils';
import {
    TermsLinkWrapper,
    Itv7TermsLinkWrapper,
    RacingButtonLinkWrapper
} from '../../components/LinkWrappers';

export const SweepDetailContainer = ({ OnEntered }) => {
    const { sweep } = useSweep();
    const { entry } = useEntry();
    const { authStore } = useAuth();
    const { openLogin } = useLoginActions();
    const { features } = useFeatures();
    const { promotions } = usePromotions();

    if (entry.hasEntered && authStore.loggedIn) {
        return OnEntered;
    }

    const startDate = get(sweep, 'event.startDate', null);
    const eventStartDateTime = dayjs(startDate);
    const now = dayjs();
    const hasEventStarted = now.isAfter(eventStartDateTime);

    const isRoundOpen = get(sweep, 'status', null) === 'open';

    const sweepOpenDate = get(sweep, 'openDate', null);
    const sweepCloseDate = get(sweep, 'closeDate', null);
    const isSweepOpen =
        (now.isSame(sweepOpenDate) || now.isAfter(sweepOpenDate)) &&
        now.isBefore(sweepCloseDate);

    const canEnterSweepstake = isRoundOpen && isSweepOpen && !hasEventStarted;

    const displayCountdownTimer = get(
        features,
        'countdown_timer_enabled',
        false
    );
    const displayBettingLinks = get(features, 'betting_links_enabled', false);

    const excludeFromBetting = checkIfExcludedFrom('bet');
    const isLoggedIn = get(authStore, 'loggedIn', false);
    const promotionsConfig = getPromotionConfig({
        promotions,
        hasEventStarted
    });

    const bettingEnabled = getBettingStatus(
        isLoggedIn,
        displayBettingLinks,
        !excludeFromBetting
    );

    return (
        <SweepDetailPage
            sweep={sweep}
            loggedIn={authStore.loggedIn}
            openLogin={openLogin}
            TermsLink={TermsLinkWrapper}
            Itv7TermsLink={Itv7TermsLinkWrapper}
            userName={authStore.user.given_name}
            ButtonLink={RacingButtonLinkWrapper}
            hasEventStarted={hasEventStarted}
            canEnterSweepstake={canEnterSweepstake}
            displayCountdownTimer={displayCountdownTimer}
            bettingEnabled={bettingEnabled}
            promotionsConfig={promotionsConfig}
        />
    );
};

SweepDetailContainer.propTypes = {
    OnEntered: PropTypes.node.isRequired
};

export default SweepDetailContainer;
